export class Button {
  public text?: string; // text and label depends on the type of button => example : super-button
  public label?: string; // text and label depends on the type of button => example : p-splitButton

  public id?: string;

  public styleClass?: string;
  public disabled?: boolean;
  public tooltip?: string;

  public icon?: string;
  public iconPosition?: string;

  public click?: () => void; // Click or command depends on the type of button => example : super-button
  public command?: () => void; // Click or command depends on the type of button => example : p-splitButton

  constructor(data?: Partial<Button>) {
    Object.assign(this, data);
  }
}
